<template>

  <div class="menu-title">
    <p>Combo Dish</p>
  </div>

  <div class="menu-sub-title">
    <p>Kimbap Combo</p>
  </div>


  <div class="combo-container-1">


    <div class="combo-grid-1">
      <div>
        <img class="menu-pic" src="../assets/ComboKimbapTteokbokki.jpg">
      </div>
      <div class="menu-text">
        <p>Kimbap & Tteokbokki (12)</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>

    <div class="combo-grid-2">
      <div>
        <img class="menu-pic" src="../assets/ComboKimbapRamen.jpg">
      </div>
      <div class="menu-text">
        <p>Kimbap & Mild Ramen</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>

    <div class="combo-grid-3">
      <div>
        <img class="menu-pic" src="../assets/ComboKimbapRamen.jpg">
      </div>
      <div class="menu-text">
        <p>Kimbap & Mussel Soup (5)</p>
        <!-- <p>11.99</p> -->
      </div>
    </div>

  </div>

  
  
  <div class="menu-sub-title">
    <p>Tempura & Mild Ramen Combo</p>
  </div>


  <div class="combo-container-2">


    <div class="combo-grid-4">
      <div>
        <img class="menu-pic" src="../assets/ComboVeggieRamen.jpg">
      </div>
      <div class="menu-text">
        <p>Veggie (5) & Ramen</p>
        <!-- <p>10.99</p> -->
      </div>
    </div>

    <div class="combo-grid-5">
      <div>
        <img class="menu-pic" src="../assets/ComboShrimpRamen.jpg">
      </div>
      <div class="menu-text">
        <p>Shrimp (3) & Ramen</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>  
  </div>



  <div class="menu-sub-title">
    <p>Tempura & Udon Combo</p>
  </div>


  <div class="combo-container-3">

    <div class="combo-grid-6">
      <div>
        <img class="menu-pic" src="../assets/ComboVeggieUdon.jpg">
      </div>
      <div class="menu-text">
        <p>Veggie (5) & Udon</p>
        <!-- <p>10.99</p> -->
      </div>
    </div>  

    <div class="combo-grid-7">
      <div>
        <img class="menu-pic" src="../assets/ComboShrimpUdon.jpg">
      </div>
      <div class="menu-text">
        <p>Shrimp (3) & Udon</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>  

  </div>


</template>


<script>

  export default {
    name: 'ComboBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 4vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-bottom: 5vw;
    color: darkblue;
  }

  .menu-sub-title {
    display: inline-flex;
    float: left;
    border: 2px solid darkblue;
    background-color: rgb(255,204,211);
    color: darkblue;
    height: 2.2rem;
    line-height: 1rem;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    font-weight: bold;
    margin-top: 1vw;
    margin-left: 6vw;
  }

  .combo-container-1, .combo-container-2, .combo-container-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
    margin-left: 1.7vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    margin-bottom: 2rem;
    color: darkblue;
  }

  .menu-sub-title {
    text-align: center;
    text-decoration: underline;
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 3rem;
    margin-left: 1rem;
    color: darkblue;
  }

  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw;
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: -0.5vw;
  }

}
  
</style>